import React from "react";
import Tilt from "react-parallax-tilt";

function Interduce() {
  return (
    <div
      className="flex flex-wrap items-center justify-center flex-col lg:flex-row relative overflow-hidden    
        bg-gradient-to-r from-slate-900 via-purple-600 to-slate-900"
    >
      {/* <img
        src="./star.jpg"
        alt=""
        className="h-full w-full object-cover opacity-10 absolute bottom-0"
      /> */}
      <div className="w-full lg:w-1/2 h-1/2 lg:h-full flex items-center justify-center flex-col my-10 lg:gap-10">
        <h1 className="flex text-white text-2xl lg:text-4xl gap-2 my-10">
          {/* LET ME <p className="text-[#ad50eb]">INTRODUCE</p> MYSELF */}
          LET ME <p className="text-[yellow]">INTRODUCE</p> MYSELF
        </h1>
        <div className="flex items-center m-auto justify-center w-11/12 lg:w-3/4 lg:mr-10">
          <span className="flex flex-col gap-3 text-white items-start  text-base justify-center font-semibold lg:text-lg">
            <p>
              👋 Hi, I'm Onkar Meher, specializing in
              <span className="text-[yellow]"> JavaScript </span> and
              <span className="text-[yellow]"> React.js.</span>
            </p>

            <p>
              💻 With experience building web apps, I thrive on problem-solving
              and creativity.
            </p>

            <p>
              My field of Interest's are building new{" "}
              <span className="text-[yellow]">Website</span> And{" "}
              <span className="text-[yellow]">Web App</span> .
            </p>

            <p>
              🚀 Passionate about exploring{" "}
              <span className="text-[yellow]">Modern Javascript Library</span>{" "}
              and <span className="text-[yellow]">Frameworks </span>
              like
              <span className="text-[yellow]"> React.js.</span>
            </p>
          </span>
        </div>
      </div>
      <div className="w-full lg:w-1/2 h-full flex items-center justify-center p-10">
        <Tilt>
          <img src="laptop-boy3.png" alt="" className="object-cover" />
        </Tilt>
      </div>
    </div>
  );
}

export default Interduce;
